import { render, staticRenderFns } from "./EndMessage.vue?vue&type=template&id=a65b63b0&"
import script from "./EndMessage.vue?vue&type=script&lang=js&"
export * from "./EndMessage.vue?vue&type=script&lang=js&"
import style0 from "./EndMessage.vue?vue&type=style&index=0&id=a65b63b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports